export default "__VITE_ASSET__70ae0cac__"